import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/paginas',
		component: Base,
		children: [
			{
				path: '',
				name: 'PaginasList',
				component: List,
				meta: {
					path: '/site/paginas',
					pai: 'Site',
					title: 'Admin - Páginas',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Páginas',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'PaginasNovo',
				component: Form,
				meta: {
					path: '/site/paginas',
					pai: 'Site',
					title: 'Admin - Páginas - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Páginas',
						class: '',
						active: false,
						url: '/site/paginas'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'PaginasEditar',
				component: Form,
				meta: {
					path: '/site/paginas',
					pai: 'Site',
					title: 'Admin - Páginas - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Páginas',
						class: '',
						active: false,
						url: '/site/paginas'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]